import type { Effect, Reducer } from 'umi';

import type { DeliveryNoteDataType } from './data';
import { getDeliveryNoteDetail } from './service';

export interface StateType {
  deliveryNote?: DeliveryNoteDataType;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'deliveryNoteModel',
  state: {
    deliveryNote: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getDeliveryNoteDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        deliveryNote: action.payload,
      };
    },
    clear() {
      return {
        deliveryNote: undefined,
      };
    },
  },
};

export default Model;
